import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { ColliRoutes } from '../colli/colli-routes';
import DeprecatedFeatureLayout from '../components/deprecated-feature-layout/deprecated-feature-layout.component';
import { PackageRoutes } from '../package/package-routes';

const TransactionOverview = lazy(() => import('../transaction/transaction-overview'));
const TransactionDetail = lazy(() => import('../transaction/transaction-detail/transaction-detail.component'));

const ColliRoute = ColliRoutes();
const PackageRoute = PackageRoutes();

export function TransactionRoutes() {
    return (
        <Route
            path='transactions'
            element={<DeprecatedFeatureLayout />}>
            <Route
                index
                element={
                    <AsyncComponent>
                        <TransactionOverview />
                    </AsyncComponent>
                }
            />
            <Route
                index
                element={<Navigate to='/admin/transactions' />}
            />
            <Route path=':transactionId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <TransactionDetail />
                        </AsyncComponent>
                    }
                />
                {PackageRoute}
                {ColliRoute}
            </Route>
        </Route>
    );
}
